import {HttpClient} from "../../service/httpClient/HttpClient";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

export class TransactionsService {
    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getTransactionList(fundID, page, filter, size = 20) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/monthly-deposits`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page: page,
                    size: size,
                    ...filter
                }
            ).then(response => resolve(response))
                .catch(reason => {
                    reject(reason)
                })
        })

    }


    getGroupAccounts(fundId, groupId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundId}/groups/${groupId}/deposit-accounts`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve)
                .catch(reject)
        })
    }

    setNewTransactions(fundID, groupId, transactions, clearFields) {

        this.loading(setLoadingStateDispatch(true))

        this.httpClient.post(
            `fund-presentation/funds/${fundID}/groups/${groupId}/monthly-deposits`,
            transactions,
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {
            clearFields()
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "تراکنشات با موفقیت افزوده شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason,"خطا در افزودن تراکنشات جدید!",this.snackbar,this.loading)
        })

    }

    getGroupTransactions(fundID, groupId, deposited_id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/groups/${groupId}/monthly-deposits/deposited-at/${deposited_id}`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    updateTransactions(fundID, transactionData) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.put(
            `fund-presentation/funds/${fundID}/monthly-deposits`,
            this.httpClient.prepareUserAccessHeader(this.token),
            transactionData
        ).then(response => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی با موفقیت انجام شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason,"خطا در بروزرسانی اطلاعات!",this.snackbar,this.loading)
        })

    }
}